import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import { includes } from 'lodash';

import { getImageURL } from '../../../api/Layers/layer-operations';
import { LAYER_TYPES } from '../../../api/Layers/Layers';

const LayerImageURLField = ({ layerType, layer }) => {
  if (includes([LAYER_TYPES.SPATIAL, LAYER_TYPES.JOIN, LAYER_TYPES.TRIDIMENSIONAL], layerType)) {
    return (
      <Form.Group>
        <Form.Label>Image Preview</Form.Label>
        <Form.Control
          type="text"
          name="imageUrl"
          defaultValue={getImageURL(layer)}
          placeholder="An image to use as preview"
        />
      </Form.Group>
    );
  }
  return '';
};
LayerImageURLField.propTypes = {
  layer: PropTypes.object.isRequired,
  layerType: PropTypes.string.isRequired
};

export default LayerImageURLField;
